import { COLS, ROWS } from './NumberPad.styles';

export function checkIsWide(params: {
  containerWidth: number;
  containerHeight: number;
  gapPx: number;
  cols?: number;
  rows?: number;
}): boolean {
  const cols = params.cols ?? COLS;
  const rows = params.rows ?? ROWS;

  const widthOfCell =
    (params.containerWidth - params.gapPx * (cols - 1)) / cols;
  const heightOfCell =
    (params.containerHeight - params.gapPx * (rows - 1)) / rows;

  return widthOfCell > heightOfCell;
}

export function checkIsWideFromEl(params: {
  el: HTMLElement | null;
  gapPx: number;
  cols?: number;
  rows?: number;
}): boolean | null {
  if (!params.el) return null;
  const rect = params.el.getBoundingClientRect();
  return checkIsWide({
    containerWidth: rect.width,
    containerHeight: rect.height,
    gapPx: params.gapPx,
    cols: params.cols,
    rows: params.rows,
  });
}

export function detectFlexGap(): boolean {
  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  (flex.style as any).rowGap = '1px';

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  document.body.appendChild(flex);
  const supported = flex.scrollHeight === 1;
  document.body.removeChild(flex);
  return supported;
}

export const getWin = (): Window | undefined =>
  typeof window !== 'undefined' ? window : undefined;
